
<template>
  <v-app id="onMltp">
    <v-main>
      <v-container fluid>  
        <v-card v-if="!loading" id="card">
          <b>{{ mltp.mltp_doelgroep.toUpperCase() }}</b> - {{mltp.mltp_nr}} - {{mltp.mltp_oms}} 
          <span v-for="(mlttRecord,i) in mltp.mltt" :key="i">
            <div style="background-color: #F5F5F5;" class="px-2 pt-1 my-1">
              <div style="display: flex; flex-direction: row; align-items: center; gap: 20px;">
                <div style="border-bottom: 1px solid;"><b>{{mlttRecord.taal_code}}  {{mlttRecord.mltt_type}}</b></div>  
                <v-btn class="primary" small @click="saveMltt(mlttRecord)">Save</v-btn>
                <v-btn class="primary" small @click="copyMltt(mlttRecord)">{{mlttRecord.mltt_type_ander}}</v-btn>
                <v-btn v-if="((mlttRecord.mltt_type == 'Test') && (((mltp.mltp_doelgroep == 'klnt' || mltp.mltp_doelgroep == 'eign') && (mltp.mltp_nr < 4750 || mltp.mltp_nr == 4800)) || mltp.mltp_doelgroep == 'inpt' && (mltp.mltp_nr >= 6100 || mltp.mltp_nr == 6020 ) || mltp.mltp_doelgroep == 'algm' && mltp.mltp_nr == 9300 || (mltp.mltp_doelgroep == 'eign-price-improvement')))" class="primary" small @click="sendMltt(mlttRecord)">Send preview mail</v-btn>
                <v-checkbox   
                  hide-details
                  dense           
                  class="mb-2"              
                  v-model="mlttRecord.textarea_wordwrap" 
                  label="Word Wrap"
                ></v-checkbox>
                <v-select
                  v-model="mlttRecord.textarea_fontsize"
                  :items="[
                    { text: 'Font small (14px)', value: '14px' },
                    { text: 'Font default (16px)', value: '16px' },
                    { text: 'Font large (18px)', value: '18px' },
                    { text: 'Font x-Large (20px)', value: '20px' }
                  ]"
                  dense
                  class="mb-2 font-width"
                  hide-details            
                ></v-select>
                <v-select
                  v-model="mlttRecord.textarea_fontname"
                  :items="fonts"
                  dense
                  class="mb-2 font-width"
                  hide-details            
                ></v-select>            
                <div v-if="i%2===0"> <!-- prod -->
                  <span v-if="mltp.mltt[i].mltt_txt===mltp.mltt[i+1].mltt_txt" style="color: green; font-weight: bold;">PROD = TEST</span>
                  <span v-else style="color: red; font-weight: bold;"> PROD ≠ TEST</span>
                </div>
                <div v-else> <!-- test -->
                  <span v-if="mltp.mltt[i].mltt_txt===mltp.mltt[i-1].mltt_txt" style="color: green; font-weight: bold;">TEST = PROD</span>
                  <span v-else style="color: red; font-weight: bold;"> TEST ≠ PROD</span>
                </div>  
              </div>            
              <v-text-field v-model="mlttRecord.mltt_subject" label="Subject"></v-text-field>
            </div> 
            <label>Mail Text:</label>
            <textarea
              v-model="mlttRecord.mltt_txt"
              class="custom-textarea"
              rows="35"
              :style="{ whiteSpace: mlttRecord.textarea_wordwrap ? 'pre-wrap' : 'pre', 
                        fontSize: mlttRecord.textarea_fontsize, 
                        fontFamily: mlttRecord.textarea_fontname }"
            ></textarea>
            <br>
          </span>  
          <navBar title="Ares - Mail templates" :info="[
              {label: 'Group: ', value: `${mltp.mltp_doelgroep.toUpperCase()}`}, 
              {label: 'Nr: ', value: `${mltp.mltp_nr}`}, 
              {label: 'Desc: ', value: `${mltp.mltp_oms}`}
            ]" :home="true" type="mltp"/>    
          <standard_dialog ref="standard_dialog" />  
          <sendMltt ref="sendMltt"></sendMltt>
        </v-card>  
      </v-container>
    </v-main>
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue"
import sendMltt from "@/components/syst/mltp/sendMltt.vue";
import standard_dialog from '@/components/ui/standard_dialog.vue';

 export default {
  components: {
    navBar,
    sendMltt,
    standard_dialog
  },
  props: ['mltp_encrid'],
  data() {
    return {
      mltp: {
        mltp_doelgroep: "",
        mltp_nr: 0,
        mltp_desc: ""
      },
      dialog: false,
      wordWrap: false, // Default to word wrap enabled
      selectedFont: "Arial",
      loading: true,
      fonts: [
        "Arial",
        "Courier New",
        "Lucida Console",
        "Consolas"      ]
    }  
  },
  mounted() {
    this.getMltt(true);
    // Select the element you want to inspect and get the default font
    const element = document.querySelector('div')
    const computedStyle = window.getComputedStyle(element)
    const defaultFont = computedStyle.fontFamily

    // check if default font is selectable. If not then push it
    if (!this.fonts.includes(defaultFont)) {
      this.fonts.push(defaultFont);
    }
  },
  methods: {
    getMltt(loadingvalue){
      this.loading = loadingvalue
      this.$axios
        .post("ares/json/ares/syst/mltp/getMltp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getMltp"
          },
          getMltp: {
             mltp_encrid: this.mltp_encrid
          }
        })
        .then(res => {
          console.log(res.data, res.data.error===true);
          if (res.data.error) {
            console.log(res.data.error);
            this.loading = false
            this.$refs.standard_dialog.open('error', 'Error', res.data.error.message);
          } else {
            console.log('we komen hier')
            this.mltp = res.data.getMltp;
            this.loading = false
          }
        })
    },
    saveMltt(mltt) { 
      this.$axios
        .post("ares/json/ares/syst/mltp/saveMltt.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveMltt"
          },
          saveMltt: {
            mltt: mltt
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveMltt.text,
              color: res.data.saveMltt.color
            });
          }
        })
    },
    copyMltt(mltt) { 
      this.$axios
        .post("ares/json/ares/syst/mltp/copyMltt.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "copyMltt"
          },
          copyMltt: {
            mltt: mltt
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.copyMltt.text,
              color: res.data.copyMltt.color
            }); 
            this.getMltt(false);
          }
        })
    },
    mltpView() {
       window.open(this.mltp.mltp_view,'_blank');
    },
    sendMltt(mltt) { 
      
      mltt.gebr_email = this.mltp.gebr_email;
      mltt.mltp_nr = this.mltp.mltp_nr;
      this.$refs.sendMltt.open(mltt);
    },
  }  

};

</script> 
<style scoped>
.custom-textarea {
  width: 100%; /* Full width */  
  overflow: auto; /* Enable both horizontal and vertical scrollbars */
  resize: both; /* Allow resizing of the textarea */
  border: 1px solid #ccc; /* Optional: Add a border */
  padding: 8px; /* Optional: Add padding */
  font-family: inherit; /* Match the font with the rest of the app */
}
.font-width{
  max-width: 200px;
}

</style>